// Libs
import React from 'react'
import _ from 'lodash'

// CSS
import './styles.scss'

const FilterPanelCheckbox = ({ number, title, sub_title, ps, options, selected, multiple = true, handleToggleOption, handleToggleAll }) => {
  const isClassNameChecked = (option) => {
    for (var i = 0; i < selected.length; i++) {
      if (selected[i].value === option.value) {
        return "filter-panel-checkbox__option filter-panel-checkbox__option--checked"
      }
    }
    return "filter-panel-checkbox__option"
  }

  return (
    <div className="filter-panel-checkbox">
      <div className="filter-panel-checkbox__header">
        <p>{number}</p>
        <p>{title}</p>
      </div>
      <p className="filter-panel-checkbox__sub-title">{sub_title}</p>
      <div className="filter-panel-checkbox__options">
        {multiple &&
          <button
            className={options.length === selected.length ?
              "filter-panel-checkbox__option filter-panel-checkbox__option--checked" :
              "filter-panel-checkbox__option"
            }
            onClick={() => handleToggleAll()}>todos</button>
        }
        {options.map(option => {
          return (
            <button
              key={option.value}
              className={isClassNameChecked(option)}
              onClick={() => handleToggleOption(option, multiple)}>{option.label}<span /></button>
          )
        })}
      </div>
    </div>
  )
}

export default FilterPanelCheckbox
